class DrawerOverlay {
  constructor(drawer, templateDrawerItem) {
    this.drawer = drawer;
    this.loader = drawer.querySelector(".loader");
    this.templateDrawerItem = templateDrawerItem;
    this.itemManager = {}
    this.drawerPopup = this.drawer.querySelector("#popupDrawer");
    this.itemsContainer = this.drawer.querySelector(".items-container");
    this.drawerMessage = this.drawer.querySelector(".message");
    const drawerCloseBtn = this.drawer.querySelector(".drawer__close-button");
    this.drawer.addEventListener("click", (e) => {
      if (e.target !== this.drawer) return;
      this.closeDrawer();
    });
    if (drawerCloseBtn) {
      drawerCloseBtn.addEventListener("click", this.closeDrawer);
    }
  }
  renderItems(lineItems, drawerItems) {
    lineItems.forEach((lineItem) => {
      const { id, key, image, price, title, quantity, variantId, properties } = lineItem;
      const item = this.templateDrawerItem.cloneNode(true);
      const productImage = item.querySelector("img");
      const productTitle = item.querySelector(".title");
      const productQuantity = item.querySelector(".quantity__input");
      const productPrice = item.querySelector(".price");

      productImage.src = image;
      productTitle.innerText = title;
      productQuantity.value = quantity;
      productQuantity.dataset.id = variantId;
      if (key) productQuantity.dataset.lineKey = key;
      productQuantity.dataset.price = price * 100; //price was divided by 100
      productPrice.innerText = "$" + (price * quantity).toFixed(2);

      // Show "Paired with" subtitle for bundle protein items
      if (properties && properties['Paired with']) {
        productTitle.innerHTML = title + '<br><span class="paired-with-label">Paired with ' + properties['Paired with'] + '</span>';
      }

      drawerItems.appendChild(item);
    });
  }
  getTotalPrice(lineItmes) {
    return lineItmes.reduce((total, item) => {
      return total + (item.price * item.quantity)
    }, 0);
  }
  renderDrawerContent(cart) {
    const lineItems = this.mapLineItmes(cart.items);
    const items_subtotal_price = cart.items_subtotal_price / 100;
    const subtotalPrice = this.drawer.querySelector(".subtotal .price");
    const shippingPrice = this.drawer.querySelector(".shipping .price");
    const grandPrice = this.drawer.querySelector(".grandtotal .price");
    const drawerMessage = this.drawer.querySelector(".message");
    const orderDates = this.drawer.querySelector(".order-dates");
    const skipWeek = this.drawer.querySelector(".skip-week");
    const itemQuantity = this.drawer.querySelector(".item-quantity");
    const price_after_discount = cart.original_total_price / 100;

    var discount_code = getCookie("discount_code");
    
    var queryString = window.location.hostname;
    queryString = queryString.split(".")[1];
    //console.log(queryString);
    
    //const urlParams = new URLSearchParams(queryString);
    var country;
    if(queryString == "com"){
      country = "USA"
    }
    else {
      country = "Canada"
    }

    itemQuantity.innerText = cart.item_count;
    subtotalPrice.textContent = "$" + parseFloat(items_subtotal_price).toFixed(2);

    if(country == "USA"){
      //document.querySelector(".shipping").style.display = "none";
      //document.querySelector(".grandtotal").style.display = "none";
      var shippingTotal = 9.95;
    }
    else{
      var shippingTotal = 6.95;
      if(items_subtotal_price>=65){
        shippingTotal = "Free"
      }
    }
    
    if(country != "USA"){  
      shippingPrice.textContent = "$" + shippingTotal;
    }
    var totalPrice = items_subtotal_price
    if(shippingPrice != "Free"){
      totalPrice = (items_subtotal_price + shippingTotal)
    }

    if(country != "USA"){
      grandPrice.innerText = "$" + parseFloat(totalPrice).toFixed(2);
    }    
    
    if(country == "Canada"){
      if (lineItems.length == 0) {
        drawerMessage.textContent = "YOUR CART IS EMPTY";
      } else {
        if(items_subtotal_price < 40 && discount_code != "GET50" ){
          drawerMessage.innerHTML = "YOU ARE BELOW THE $40.00 MIN ORDER AMOUNT.";
        }
        else{
          const awayFromFreeDelevery = (65 - price_after_discount);
          if (awayFromFreeDelevery > 0) {
            const formatedPrice = "$" + parseFloat(awayFromFreeDelevery).toFixed(2);
            drawerMessage.innerHTML = `ONLY <span class="red-price">${formatedPrice}</span> AWAY FROM FREE DELIVERY`;
          } else {
            drawerMessage.innerHTML = "YOU HAVE FREE SHIPPING!";
          }  
        }
      }
    }

    this.itemsContainer.innerHTML = "";
    this.renderItems(lineItems, this.itemsContainer);
    if (this.itemManager.customerId) {
      const arrivingDate = orderDates.querySelector(".arriving-date");
      const changable = orderDates.querySelector(".changeable");
      const { nextBillingDate } = this.itemManager.subscriptionCache.data;
      const billingDate = new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
      }).format(new Date(nextBillingDate));

      //insert the actual date
      const changableUntilDate = new Date(nextBillingDate);
      changableUntilDate.setDate(changableUntilDate.getDate()); //Charge Date

      const arriveDateActual = new Date(nextBillingDate);
      arriveDateActual.setDate(arriveDateActual.getDate() + 4);


      const arriveDateActualDay = new Intl.DateTimeFormat("en", {
        weekday: "long",
        month: "long",
        day: "numeric",
      }).format(arriveDateActual);
      arrivingDate.innerText = arriveDateActualDay;

      const changableUntilWeekday = new Intl.DateTimeFormat("en", {
        weekday: "long",
      }).format(changableUntilDate); //get weekday
      const changableUntilTime = new Intl.DateTimeFormat("en", {
        hour: "numeric",
        minute: "numeric",
      }).format(changableUntilDate); //get hour and mintue

      changable.innerHTML = `Changable until ${changableUntilWeekday} at ${changableUntilTime}`;
      const bannerOrderDates = document.querySelector(
        ".subscription-banner .order-dates"
      );

      bannerOrderDates.replaceWith(orderDates.cloneNode(true));

      orderDates.style.display = "block";
      skipWeek.style.display = "block";
    } else {
      orderDates.style.display = "none";
      skipWeek.style.display = "none";
    }
  }

  
    async openDrawer() {

    const element = this.itemsContainer;
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }

    var queryString = window.location.hostname;
    queryString = queryString.split(".")[1];
    //console.log(queryString);
    
    //const urlParams = new URLSearchParams(queryString);
    var country;
    if(queryString == "com"){
      country = "USA"
    }
    else {
      country = "Canada"
    }

    
    this.itemsContainer.innerHTML = "";
    if(country == "Canada"){
      this.drawerMessage.innerHTML = "";
    }
    this.drawer.style.display = "block";
    this.loader.style.display = "grid";
    this.drawerPopup.style.display = "flex";

    let currentUrl = window.location.pathname;

    // check filters
    let filtersChecked = false;
    document.querySelectorAll("[id*=Filter-filter]").forEach(f => {
      if (f.checked) filtersChecked = true;
    });

    const fetchOptions = { credentials: 'same-origin', cache: 'no-store' };

  
  // ✅ Instead of rebuilding the cart, sync card inputs from cart (READ ONLY)
  if (currentUrl.includes("collections") && filtersChecked === false) {
    const cart = await fetch("/cart.js", fetchOptions).then(r => r.json());

    // Build lookups: standalone qty (excludes bundle) and total qty per variant
    const standaloneQtyByVariant = new Map();
    const totalQtyByVariant = new Map();
    const hasBundleByVariant = new Set();

    cart.items.forEach(item => {
      const vid = String(item.variant_id);
      totalQtyByVariant.set(vid, (totalQtyByVariant.get(vid) || 0) + item.quantity);

      if (item.properties && item.properties['Paired with']) {
        hasBundleByVariant.add(vid);
      } else {
        standaloneQtyByVariant.set(vid, (standaloneQtyByVariant.get(vid) || 0) + item.quantity);
      }
    });

    // Prevent quantity-input handlers from firing cart writes during hydration
    window.__IGO_HYDRATING_CARDS__ = true;

    document.querySelectorAll("quantity-input").forEach(qi => {
      const variantId = String(qi.dataset.id || "");
      // Protein variants with bundle lines show only standalone qty
      const newQty = hasBundleByVariant.has(variantId)
        ? (standaloneQtyByVariant.get(variantId) || 0)
        : (totalQtyByVariant.get(variantId) || 0);

      // Grab the actual input inside the component
      const input = qi.querySelector(".quantity__input");
      if (!input) return;

      // Set value WITHOUT triggering events
      input.value = String(newQty);

      // If you have any purely-visual UI refresh method, call it here.
      // DO NOT call handleMinusButton/handlePlusButton (those can write to cart)
      // Example (optional): qi.updateButtons?.();

    });

    window.__IGO_HYDRATING_CARDS__ = false;

    // Render drawer using the cart you already fetched
    this.loader.style.display = "none";
    this.renderDrawerContent(cart);
    return;
  }

    // fallback: normal flow
    const cart = await fetch("/cart.js", fetchOptions).then(r => r.json());
    this.loader.style.display = "none";
    this.renderDrawerContent(cart);
  }
  
  mapLineItmes(items) {
    return items.map(item => ({
      id: item.id,
      key: item.key,
      variantId: item.variant_id,
      price: item.final_price / 100,
      quantity: item.quantity,
      image: item.image,
      title: item.product_title,
      properties: item.properties || {}
    }))
  }
  closeDrawer() {
    this.drawerPopup = document.querySelector("#popupDrawer");
    this.drawerPopup.classList.add("closing-drawer");
    setTimeout(() => {
      this.drawerPopup.classList.remove("closing-drawer");
      this.drawerPopup.style.display = "none";
      if (!this.drawer) {
        this.drawer = document.querySelector(".drawer-overlay")
      }
      this.drawer.style.display = "none";
    }, 500);
  };
}

const drawerTemplate = document.getElementById('drawerOverlayTemplate');
const templateDrawer = drawerTemplate.content.querySelector('.drawer-overlay');
const drawerItemTemplate = document.getElementById('drawerItemTemplate');
this.templateDrawerItem = drawerItemTemplate.content.querySelector(".item");
const drawer = templateDrawer.cloneNode(true);
document.body.appendChild(drawer)
const drawerOverlay = new DrawerOverlay(drawer, templateDrawerItem);

class DrawerCloseButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", drawerOverlay.closeDrawer);
  }
}
customElements.define("drawer-close-button", DrawerCloseButton);

class DrawerOpenButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => {
      drawerOverlay.openDrawer()
    });
  }
  fetchCartItems() {
    const itemsContainer = document.getElementById("itemsContainer");
    const loading = itemsContainer.appendChild(document.createElement("h2"));
    loading.className = "loading";
    loading.innerText = "loading...";
    fetch("/cart.js", {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then((response) => response.json())
      .then((data) => {
        loading.remove();
        drawerOverlay.openDrawer(data)
      });
  }
}
customElements.define("drawer-open-button", DrawerOpenButton);

function formatPrice(price) {
  return "$" + parseFloat(price / 100).toFixed(2);
}

